import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门题材分类</h2>
          <p className="mt-2 text-sm text-foreground-600">按双女主漫画题材快速筛选你喜欢的类型</p>
        </div>
        <Link
          to="/category"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部分类 <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category?genre=${encodeURIComponent(cat.key)}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-xl`} />
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-semibold text-foreground-950">{cat.name}</span>
              <span className="mt-0.5 block truncate text-xs text-foreground-500">{cat.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}